const getOneLinkBaseUrl = () => {
  if(window.pageData.country === 'au') {
    return window.pageData.oneLinkURLAu
  }
  return window.pageData.oneLinkURL
}

export default getOneLinkBaseUrl